import { Link } from 'react-router-dom';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  image: string;
}

const blogPosts: BlogPost[] = [
  {
    id: 1,
    title: 'Best Fall Camping Spots in Hudson Valley',
    excerpt: 'Discover the most stunning autumn camping destinations where foliage meets adventure.',
    category: 'Destinations',
    author: 'Sarah Mitchell',
    date: 'Jan 15, 2025',
    image: 'https://public.readdy.ai/ai/img_res/809c727b245f4176495ca652afdcf863.jpg',
  },
  {
    id: 2,
    title: 'RV Maintenance Tips for Winter Storage',
    excerpt: 'Essential checklist to prepare your RV for the cold season and ensure it stays in top condition.',
    category: 'Tips & Guides',
    author: 'Mike Johnson',
    date: 'Jan 12, 2025',
    image: 'https://readdy.ai/api/search-image?query=RV%20camper%20maintenance%20in%20winter%2C%20winterized%20RV%20covered%20with%20snow%2C%20RV%20storage%20preparation%2C%20cold%20weather%20camping%20vehicle%2C%20simple%20clean%20background&width=600&height=400&seq=blog-rv-winter-1&orientation=landscape',
  },
  {
    id: 3,
    title: 'Family-Friendly Campgrounds Near NYC',
    excerpt: 'Top picks for camping with kids, featuring playgrounds, swimming, and easy hiking trails.',
    category: 'Family',
    author: 'Emily Chen',
    date: 'Jan 10, 2025',
    image: 'https://readdy.ai/api/search-image?query=family%20camping%20with%20children%2C%20kids%20playing%20at%20campground%2C%20family%20tent%20camping%2C%20playground%20and%20camping%20area%2C%20happy%20outdoor%20family%20activities%2C%20simple%20background&width=600&height=400&seq=blog-family-camp-1&orientation=landscape',
  },
  {
    id: 4,
    title: 'Hiking the Appalachian Trail Through NY',
    excerpt: 'A comprehensive guide to the New York section of the AT with camping recommendations.',
    category: 'Hiking',
    author: 'David Torres',
    date: 'Jan 8, 2025',
    image: 'https://readdy.ai/api/search-image?query=Appalachian%20Trail%20hiking%20in%20New%20York%2C%20mountain%20trail%20through%20forest%2C%20backpacker%20on%20scenic%20trail%2C%20wilderness%20hiking%20path%2C%20beautiful%20mountain%20landscape%2C%20simple%20natural%20background&width=600&height=400&seq=blog-at-hiking-1&orientation=landscape',
  },
  {
    id: 5,
    title: 'Campfire Cooking: Easy Outdoor Recipes',
    excerpt: 'Delicious and simple meals you can prepare over an open fire during your camping trip.',
    category: 'Cooking',
    author: 'Lisa Anderson',
    date: 'Jan 5, 2025',
    image: 'https://readdy.ai/api/search-image?query=campfire%20cooking%20outdoors%2C%20food%20being%20prepared%20over%20open%20fire%2C%20camping%20meal%20preparation%2C%20cast%20iron%20cooking%20at%20campsite%2C%20cozy%20evening%20campfire%2C%20simple%20background&width=600&height=400&seq=blog-campfire-cook-1&orientation=landscape',
  },
  {
    id: 6,
    title: 'Wildlife Watching in Hudson Valley Parks',
    excerpt: 'Best locations and times to spot deer, birds, and other wildlife in their natural habitat.',
    category: 'Nature',
    author: 'Robert Kim',
    date: 'Jan 3, 2025',
    image: 'https://readdy.ai/api/search-image?query=wildlife%20in%20Hudson%20Valley%2C%20deer%20in%20forest%2C%20bird%20watching%20in%20nature%2C%20natural%20habitat%20with%20animals%2C%20peaceful%20woodland%20scene%2C%20simple%20natural%20background&width=600&height=400&seq=blog-wildlife-1&orientation=landscape',
  },
];

const BlogPreview = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <p className="text-sm uppercase tracking-wider text-gray-500 mb-4">LATEST STORIES</p>
          <h2 className="font-serif text-6xl font-bold text-gray-900">
            Tales from<br />
            the Trail
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-12">
          {blogPosts.map((post) => (
            <article
              key={post.id}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-forest/10 text-forest text-xs font-medium rounded-full mb-3">
                  {post.category}
                </span>
                
                <h3 className="font-bold text-xl text-gray-900 mb-3 group-hover:text-forest transition-colors">
                  {post.title}
                </h3>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {post.excerpt}
                </p>
                
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-forest/20 rounded-full flex items-center justify-center">
                    <span className="text-forest text-xs font-bold">
                      {post.author.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">{post.author}</p>
                    <p className="text-xs text-gray-500">{post.date}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 px-8 py-3 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap"
          >
            View All Stories
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;